import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from './common/session.service';
import { isPlatformBrowser } from '@angular/common';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(SessionService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if(isPlatformBrowser(platformId)){
    if (authService.isConnected() == false) {
        router.navigate(['/login']);
        return false;
    }
  }else {
    console.log('your are not running in browser');
  }
  return true;
};
